import React, { useEffect, useState } from "react";
import {
  getAllCases,
  createCase,
  updateCase,
  deleteCase,
} from "../../services/caseHearingService";
import CaseHearingForm from "../../components/adiminComponents/CaseHearingForm";
import CaseHearingTable from "../../components/adiminComponents/CaseHearingTable";

export default function CaseHearingPage() {
  const [cases, setCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState(null);

  const loadCases = async () => {
    const res = await getAllCases();
    setCases(res.data);
  };

  useEffect(() => {
    loadCases();
  }, []);

  const handleSave = async (data) => {
    if (selectedCase) {
      await updateCase(selectedCase.id, data);
    } else {
      await createCase(data);
    }
    setSelectedCase(null);
    loadCases();
  };

  const handleEdit = (caseData) => {
    setSelectedCase(caseData);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this case?")) {
      await deleteCase(id);
      loadCases();
    }
  };

  return (
    <div className="container py-4">
      <CaseHearingForm onSubmit={handleSave} selectedCase={selectedCase} />
      <CaseHearingTable cases={cases} onEdit={handleEdit} onDelete={handleDelete} />
    </div>
  );
}
